import React from "react";
import GetAllParents from "../Users/GetAllParents";
import { addDoc, collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import HelperForMetaData from "../../Helpers/HelperForMetaData";
import GetAbsentStudents from "../Admin/Attendance/GetAbsentStudents";

const StudentAbsentNotification = async (AttendanceObject) => {
  let resp = await GetAllParents();
  const Children = [];
  const ParentIds = [];
  const deviceIDs = [];
  const Test = [];

  // AttendanceObject.Students.forEach(async (student) => {
  //   if (student.IsPresent === false) {
  //     const absentStudentsData = await GetAbsentStudents(student.id);
  //     Test.push(absentStudentsData);
  //     console.log("Test", Test);
  //   }
  // });

  // Get only the StudentRegistrationNo and doc id from  parents array of objects
  resp.forEach((parent) => {
    Children.push({
      id: parent.id,
      childrenRegNo: parent.AdditionalDetails.StudentRegistrationNo,
    });
  });

  // Get the doc id's of all the parents when their children is absent
  AttendanceObject?.Students.forEach((std) => {
    Children.forEach(async (child) => {
      if (
        !std.IsPresent &&
        child?.childrenRegNo.find((item) => item?.StudentId === std.id)
      ) {
        ParentIds.push(child.id);
      }
    });
  });

  // Get the parent device id's
  for (let i = 0; i < ParentIds.length; i++) {
    const ref = collection(db, "DeviceIds", ParentIds[i], "device_ids");

    let snapshot = await getDocs(ref);
    snapshot.forEach((doc) => {
      deviceIDs.push(doc.id);
    });
  }

  const notificationObj = {
    title: "Student Absent",
    dateTime: AttendanceObject.AttendanceDate,
    ClassID: AttendanceObject.ClassID,
    CourseID: AttendanceObject.CourseID,
    device_id: deviceIDs,
    receiver_id: ParentIds,
    is_deleted: false,
    is_seen: false,
    description: "Your child was absent today",
    ...HelperForMetaData({}),
  };
  if (deviceIDs.length !== 0 || deviceIDs !== null || deviceIDs !== undefined) {
    try {
      const NotificationsCollection = collection(db, "notifications");

      await addDoc(NotificationsCollection, notificationObj);
    } catch (error) {
      console.log(error);
    }
  }
};

export default StudentAbsentNotification;
